export default "__VITE_ASSET__CpOGQ1yw__"